import {
    ListItemText as UiListItemText,
    MenuItem as UiMenuItem,
    MoreMenu as UiMoreMenu,
    styled,
} from "@l2r-front/l2r-ui"

const MENU_ITEM_HEIGHT = 42

export const MoreMenu = styled(UiMoreMenu)({
    "& .MuiMenu-paper": {
        maxWidth: "none",
    },
})

export const MenuItem = styled(UiMenuItem)(() => ({
    height: MENU_ITEM_HEIGHT,
}))

export const ListItemText = styled(UiListItemText)(() => ({
    "& .MuiTypography-root": {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
    },
}))
export const ContentWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(1),
}))